export const CARE_MONTH_KEY = 'care_month';
export const CARE_ROWS_KEY = 'care_month_rows';
export const CARE_READINESS_KEY = 'care_month_readiness';
export const CARE_HISTORY_KEY = 'care_month_history';
export const CARE_WRITE_KEY = 'care_month_write';
export const careBillingUrl = (path: string) => `scheduling/care-billing/${path}`;
